import GlobalTooltip from "../../../components/common/GlobalTooltip";
import Edit from "../../../assets/Edit";
import UserRound from "../../../assets/UserRound";
import UsersRound from "../../../assets/UsersRound";
import Login from "../../../assets/Login";
import UpgradeLicense from "../../../assets/UpgradeLicense";
import LicenseHistory from "../../../assets/LicenseHistory";
import Delete from "../../../assets/Delete";

const LicenseActionButtons = ({
  item,
  onEdit,
  onClientList,
  onEmployeeList,
  onAdminLogin,
  onUpgrade,
  onHistory,
  onDelete,
}) => {
  return (
    <div className="flex items-center gap-2">
      <GlobalTooltip title="View License History">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onHistory(item);
          }}
        >
          <LicenseHistory className="size-5" />
        </button>
      </GlobalTooltip>
      <GlobalTooltip title="Edit License">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onEdit(item);
          }}
        >
          <Edit />
        </button>
      </GlobalTooltip>
      <GlobalTooltip title="Client List">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClientList(item);
          }}
        >
          <UserRound className="size-5" />
        </button>
      </GlobalTooltip>
      <GlobalTooltip title="Employee List">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onEmployeeList(item);
          }}
        >
          <UsersRound className="size-5" />
        </button>
      </GlobalTooltip>
      {
        item?.license?.status !== "active" && (
          <GlobalTooltip title="Send Payment Link">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onUpgrade(item);
              }}
            >
              <UpgradeLicense className="size-5" />
            </button>
          </GlobalTooltip>
        )
      }
      <GlobalTooltip title="Delete Permanently">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(item);
          }}
        >
          <Delete color="#000" />
        </button>
      </GlobalTooltip>
      <GlobalTooltip title="Login Admin">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onAdminLogin(item);
          }}
          className={`${
            item?.license?.admin_portal_url ? "" : "cursor-not-allowed"
          }`}
        >
          <Login />
        </button>
      </GlobalTooltip>
    </div>
  );
};

export default LicenseActionButtons;
